import { createReducer } from 'deox';
import produce from 'immer';
import { AppState } from './types';
import { setAppStateAction } from './actions';

const isUserLogged = (): boolean => {
  const token = localStorage.getItem('access-token');
  return !!token;
};

const initialState: AppState = {
  loading: false,
  logged: isUserLogged(),
};

export const appReducer = createReducer(initialState, handle => [
  handle(setAppStateAction, (state, { payload }) => {
    return produce(state, draft => {
      draft.loading = payload.loading;
      draft.logged = payload.logged;
    });
  }),
]);
